/* eslint-disable */
import { Fragment } from "react"
import {
	Box,
	Grid,
	Dialog,
	Button,
	DialogContent,
	DialogTitle,
	useMediaQuery,
	useTheme,
	Divider,
} from "@mui/material"

import { makeStyles } from "makeStyles"

import Icon from "@mdi/react"
import { mdiHelpCircleOutline, mdiClose, mdiTruck } from "@mdi/js"

import useToggle from "../../../../../hooks/useToggle"

const useStyles = makeStyles()((theme) => ({
	p: {
		color: "#536767",
	},
}))

const MeasureCylinderDialog = () => {
	const { classes } = useStyles()
	const theme = useTheme()
	const fullScreen = useMediaQuery(theme.breakpoints.down("md"))
	const [isOpen, toggleIsOpen] = useToggle()

	return (
		<Fragment>
			<Button
				onClick={toggleIsOpen}
				style={{
					display: "flex",
					fontSize: "12px",
					paddingLeft: 0,
					textDecoration: "underline",
				}}
			>
				<Icon
					path={mdiHelpCircleOutline}
					size={0.6}
					style={{ marginLeft: "4px", marginRight: "5px" }}
				/>
				Wie messe ich einen Zylinder?
			</Button>
			<Dialog
				fullScreen={fullScreen}
				maxWidth={"md"}
				open={isOpen}
				onClose={toggleIsOpen}
				aria-labelledby="delivery-dialog"
			>
				<DialogTitle id="delivery-dialog-title">
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
						}}
					>
						<div className="h2">Wie messe ich einen Zylinder</div>
						<Button onClick={toggleIsOpen}>
							<Icon path={mdiClose} size={1} color="blackk" />
						</Button>
					</div>
					<Box mt={1}></Box>
					<p style={{ color: "#536767", fontSize: "15px" }}>
						Sie können Ihre Schließzylinder entweder eingebaut oder auch im ausgebauten
						Zustand messen. Wie Sie die Maße korrekt ermitteln, zeigen folgende
						Abbildungen:
					</p>
				</DialogTitle>
				<DialogContent>
					<Grid container spacing={3}>
						<Grid item xs={12} md={4}>
							<Box mt={3}>
								<img
									alt="eingebauter-zustand"
									src="https://res.cloudinary.com/safehero/image/upload/v1573210742/ProductDetailPage/eingebauter-zustand.svg"
									style={{ width: "100%", maxHeight: "200px" }}
								/>
							</Box>
						</Grid>
						<Grid item xs={12} md={8}>
							<div>
								<strong>Im eingebauten Zustand:</strong>
							</div>
							<p className={classes.p}>
								Für den perfekten Sitz: Messen Sie vor dem Kauf die Abstände vom
								Mittelpunkt der Schraube, die Ihren Zylinder fixiert, bis zur
								äußeren <strong>(A)</strong> und inneren Seite <strong>(B)</strong>{" "}
								der Tür.
							</p>
							<p className={classes.p}>
								Beim eingebauten Zylinder misst man ausgehend von der Mitte des in
								der Tür eingebauten Schlosses. Dazu orientiert man sich am Besten an
								der Zylinderbefestigungsschraube und misst bis an die Enden des
								Zylinders auf der Innen- und Außenseite. So ergeben sich zwei Maße,
								einmal Innen bis zur Mitte des Schlosses und einmal von Außen bis
								zur Mitte des Schlosses. Die Zylinderlängen beginnen auf jeder Seite
								bei 30 bzw. 31 mm und sind in 5 mm Schritten bis maximal 85 bzw 86
								mm erhältlich.
							</p>
						</Grid>
					</Grid>

					<Grid container spacing={3}>
						<Grid item xs={12} md={8}>
							<div>
								<strong>Im ausgebauten Zustand:</strong>
							</div>
							<p className={classes.p}>
								Für eine exakte Messung empfehlen wir, den bestehenden Zylinder
								auszubauen und abzumessen. Dazu stecken Sie einen Schlüssel an und
								drehen die Zylinderbefestigungsschraube heraus. Jetzt kann der
								Zylinder herausgezogen werden. Sollte sich die Schließnase verhaken,
								drehen Sie bitte den Schlüssel, bis sich der Zylinder sanft
								entfernen lässt.{" "}
							</p>
							<p className={classes.p}>
								Nun können Sie den Zylinder, ausgehend vom Befestigungsloch in der
								Mitte, auf beiden Seiten abmessen. Wenn beide Längen feststehen,
								können Sie Ihren neuen Zylinder bestellen.
							</p>
						</Grid>
						<Grid item xs={12} md={4}>
							<Box my={3}>
								<img
									alt="ausgebauter-zustand"
									src="https://res.cloudinary.com/safehero/image/upload/v1573210561/ProductDetailPage/ausgebauter-zustand.svg"
									style={{ width: "100%" }}
								/>
							</Box>
						</Grid>
					</Grid>
				</DialogContent>
			</Dialog>
		</Fragment>
	)
}

export default MeasureCylinderDialog
